// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as V3ClozeBucketProvider$LiteracyplanetTupperware from "./V3ClozeBucketProvider.res.mjs";

var overClassName = "bg-[#d2dcf0] select-none min-h-60 p-2";

var dropClassName = "bg-[#f2f6f8] select-none min-h-60 p-2";

function PilotClozeBucketProvider$HiddenDrag(props) {
  var __marked = props.marked;
  var marked = __marked !== undefined ? __marked : false;
  return React.createElement("div", {
              style: {
                cursor: marked ? "default" : "pointer",
                opacity: "0.5",
                userSelect: "none"
              },
              onClick: props.onClick
            }, props.children);
}

var HiddenDrag = {
  make: PilotClozeBucketProvider$HiddenDrag
};

function renderDragOverlayComponent(children) {
  return React.createElement("div", {
              className: "whitespace-nowrap	bg-[#f2f6f8] cursor-pointer"
            }, children);
}

function renderAlreadyDraggedPlaceholder(onClick, children) {
  return React.createElement(PilotClozeBucketProvider$HiddenDrag, {
              onClick: onClick,
              children: children
            });
}

function renderAlreadyDraggedAndMarkedPlaceholder(onClick, children) {
  return React.createElement(PilotClozeBucketProvider$HiddenDrag, {
              marked: true,
              onClick: onClick,
              children: children
            });
}

function renderDroppedComponent(onClick, children) {
  return React.createElement("button", {
              className: "cursor-pointer block text-left",
              onClick: onClick
            }, children);
}

function renderCorrectDroppedComponent(onClick, children) {
  return React.createElement("div", {
              className: "flex gap-2 p-2 items-center bg-lpTickBackground",
              onClick: onClick
            }, React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                  className: "w-5 h-5 fill-lpTick"
                }), children);
}

function renderIncorrectDroppedComponent(onClick, children) {
  return React.createElement("div", {
              className: "flex gap-2 p-2 items-center bg-lpCrossBackground",
              onClick: onClick
            }, React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                  className: "w-5 h-5 fill-lpCross"
                }), children);
}

function PilotClozeBucketProvider(props) {
  return React.createElement(V3ClozeBucketProvider$LiteracyplanetTupperware.make, {
              overClassName: overClassName,
              dropClassName: dropClassName,
              renderDragOverlayComponent: renderDragOverlayComponent,
              renderAlreadyDraggedPlaceholder: renderAlreadyDraggedPlaceholder,
              renderAlreadyDraggedAndMarkedPlaceholder: renderAlreadyDraggedAndMarkedPlaceholder,
              renderDroppedComponent: renderDroppedComponent,
              renderCorrectDroppedComponent: renderCorrectDroppedComponent,
              renderIncorrectDroppedComponent: renderIncorrectDroppedComponent,
              questionIndex: props.questionIndex,
              children: props.children
            });
}

var make = PilotClozeBucketProvider;

var $$default = PilotClozeBucketProvider;

export {
  overClassName ,
  dropClassName ,
  HiddenDrag ,
  renderDragOverlayComponent ,
  renderAlreadyDraggedPlaceholder ,
  renderAlreadyDraggedAndMarkedPlaceholder ,
  renderDroppedComponent ,
  renderCorrectDroppedComponent ,
  renderIncorrectDroppedComponent ,
  make ,
  $$default as default,
}
/* react Not a pure module */
